import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const FAQS = [{
  q: '¿Cómo recibo el material?',
  a: 'Una vez confirmado el pago, recibirás un correo electrónico automáticamente con el enlace de acceso a la carpeta de Google Drive donde está todo el material organizado y listo para descargar.'
}, {
  q: '¿Puedo editarlo?',
  a: '¡Sí! El pack incluye las versiones en PDF listas para imprimir y también los enlaces a las plantillas editables (generalmente en Canva o Word) para que puedas adaptar lo que necesites a tu grupo.'
}, {
  q: '¿Sirve para todos los niveles?',
  a: 'El material está diseñado con un enfoque multinivel, cubriendo desde A1 hasta B2. Cada tomo tiene actividades graduadas para que puedas usar la misma temática con distintos cursos.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí, tenés 7 días de garantía de satisfacción. Si sentís que el material no es lo que esperabas o no te sirve, nos escribís y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Qué formato tiene?',
  a: 'Todo el material es 100% digital. No enviamos nada físico. Esto te permite tener acceso inmediato, imprimir solo lo que necesitás y no pagar costos de envío.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-orange-50/40" data-id="element-76">
      <div className="max-w-3xl mx-auto px-4" data-id="element-77">
        <div className="text-center mb-12" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 uppercase" data-id="element-79">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-2 bg-orange-500 mx-auto mt-4 rounded-full" data-id="element-80"></div>
        </div>

        <div className="space-y-4" data-id="element-81">
          {FAQS.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-2xl overflow-hidden bg-gray-50" data-id="element-82">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-83">
                <span className="font-bold text-lg text-gray-900" data-id="element-84">{faq.q}</span>
                <ChevronDownIcon className={`w-6 h-6 text-orange-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-85" />
              </button>
              <AnimatePresence data-id="element-86">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-87">
                    <div className="p-6 pt-0 text-gray-600 font-medium leading-relaxed border-t border-gray-100" data-id="element-88">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}